export default __webpack_public_path__ + "static/media/crypto_bot_user.bf615d73.png";